import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-11', 'Number11', [["path",{"d":"M8 20v-16l-5 5"}],["path",{"d":"M18 20v-16l-5 5"}]]);